/* [04] VRT V3 - real Shopify materials, model information and hero-to-buy composition */
(() => {
 "use strict";
 const rootSelector='.product-information[data-pdp-reference-04="true"]';
 const instances=new WeakMap(),seen=new Set();
 let raf=0;
 let headerPortal=null;

 // Shopify renders #header-group inside .page-wrapper. On mobile PDPs the
 // independent page scroller can carry its supposed fixed header away.
 // Keep the ORIGINAL node and all event handlers; temporarily move its group
 // to <body> so its fixed positioning uses the visual viewport.
 function attachHeaderToViewport(){
   if(headerPortal)return;
   const group=document.getElementById("header-group");
   if(!group||!group.parentNode||!document.body)return;
   const marker=document.createComment("[04] PDP header home");
   group.parentNode.insertBefore(marker,group);
   headerPortal={group,marker};
   document.body.insertBefore(group,document.body.firstChild);
   document.documentElement.classList.add("pdpref04-header-portal");
 }
 function restoreHeaderPosition(){
   if(!headerPortal)return;
   const {group,marker}=headerPortal;
   if(marker.parentNode)marker.parentNode.replaceChild(group,marker);
   else marker.remove();
   headerPortal=null;
   document.documentElement.classList.remove("pdpref04-header-portal");
 }
 const tidy=s=>(s||"").replace(/\s+/g," ").trim().toLowerCase();
 const mobile=()=>matchMedia("(max-width: 1024px), (hover: none) and (pointer: coarse) and (max-width: 1366px)").matches;

 function accordionRow(details,type){
   return [...details.querySelectorAll(".accordion details")].find(node=>{
     const name=tidy(node.querySelector("summary")?.textContent);
     return type==="details"? /^(details|informazioni|information)\b/.test(name) :
       /^(materials|materiali)\b/.test(name);
   }) || null;
 }
 function rowWrapper(row){return row?.closest("accordion-custom")||row;}
 function ensureMaterialsDisclosure(state){
   const original=accordionRow(state.details,"materials");
   if(original)return original;
   const materialNote=state.details.querySelector(".pdp-material-note:not(.pdpref04-material-in-accordion)");
   const host=state.details.querySelector(".accordion");
   if(!materialNote||!host)return null;
   state.materialOriginal={
     note:materialNote,parent:materialNote.parentNode,nextSibling:materialNote.nextSibling
   };
   const wrapper=document.createElement("div");
   wrapper.className="pdpref04-generated-materials";
   state.generatedMaterials=wrapper;
   const row=document.createElement("details");
   row.className="details";
   const summary=document.createElement("summary");
   summary.className="details__header";
   const heading=document.createElement("span");
   heading.className="pdpref04-heading-label";
   heading.textContent="Materials";
   summary.append(heading);
   const body=document.createElement("div");
   body.className="details-content";
   materialNote.classList.add("pdpref04-material-in-accordion");
   body.append(materialNote);
   row.append(summary,body);
   wrapper.append(row);
   host.append(wrapper);
   return row;
 }
 function makeHeaderLinks(state){
   const {details}=state;
   const source=details.querySelector(".pdp-shipping-summary");
   const header=details.querySelector(":scope > .group-block > .group-block-content");
   if(!header||header.querySelector(".pdpref04-intro"))return;
   const intro=document.createElement("nav");
   intro.className="pdpref04-intro";intro.setAttribute("aria-label","Product details and materials");
   const links=document.createElement("div"); links.className="pdpref04-intro__links";
   for(const [type,text] of [["details","Details"],["materials","Materials"]]){
     const row=accordionRow(details,type);if(!row)continue;
     const btn=document.createElement("button");btn.type="button";btn.textContent="["+text+"]";
     btn.addEventListener("click",()=>revealAccordion(row));
     links.append(btn);
     const wrapper=rowWrapper(row);
     state.originalRows.push({row,wrapper,originalOpen:row.open});
     // The native Details/Materials accordions MUST remain in the lower
     // information list. Keep them closed, but never hide their headings.
     row.removeAttribute("open");
     wrapper?.classList?.remove("pdpref04-source-collapsed","pdpref04-source-revealed");
   }
   if(!links.children.length)return;
   intro.append(links);
   state.intro=intro;
   // Insert immediately after the real Shopify price, before its shipping summary.
   // The existing grid is flattened via display: contents.
   if(source?.parentElement)source.insertAdjacentElement("beforebegin",intro);
   else header.firstElementChild?.insertAdjacentElement("afterend",intro);
 }
 function moveMaterials(state){
   const row=accordionRow(state.details,"materials");
   const note=state.details.querySelector(".pdp-material-note:not(.pdpref04-material-in-accordion)");
   const body=row?.querySelector(".details-content");
   if(!row||!note||!body)return;
   if(!state.materialOriginal)state.materialOriginal={
     note,parent:note.parentNode,nextSibling:note.nextSibling
   };
   note.classList.add("pdpref04-material-in-accordion");
   body.insertAdjacentElement("afterbegin",note);
 }
 function moveModelInfo(state){
   const details=state.details;
   const guide=details.querySelector(".pdp04-size-guide-link");
   const source=details.querySelector('[class*="text_8MUfyJ"]');
   const legend=guide?.closest("legend");
   if(!guide||!source||!legend||legend.querySelector(".pdpref04-model-note"))return;
   const text=source.textContent.trim();
   if(!text)return;
   const note=document.createElement("span");note.className="pdpref04-model-note";
   note.textContent=text;
   guide.insertAdjacentElement("afterend",note);
   state.modelNote=note;state.modelSource=source;
   source.classList.add("pdpref04-model-source-hidden");
 }
 function revealAccordion(row){
   if(!row)return;
   const wrapper=rowWrapper(row);
   wrapper?.classList.remove("pdpref04-source-collapsed");
   wrapper?.classList.add("pdpref04-source-revealed");
   row.open=true;
   requestAnimationFrame(()=>{
     row.scrollIntoView({behavior:matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",block:"start"});
     row.querySelector("summary")?.focus({preventScroll:true});
   });
 }
  function menuIsOpen(){
   return !!document.querySelector('.nav04--mobile [data-nav04-drawer][open], header-drawer #Details-menu-drawer-container[open]');
 }
 function sync(state){
   if(!mobile())return;
   if(!state.root.isConnected){teardown(state);return;}
   const {root,details,dock,buy}=state;
   const native=details.querySelector('.buy-buttons-block button[name="add"]');
   const waiting=details.querySelector(".buy-buttons-block [data-e04-enter-room]");
   state.native=waiting||native;
   buy.disabled=!state.native||(!waiting&&(native?.disabled||native?.getAttribute("aria-disabled")==="true"));
   const label=buy.querySelector("[data-pdpref-buy-label]");
   const raw=waiting?"WAITING ROOM ↗":
     (native?.querySelector(".pdp04-atc-label")?.textContent?.trim()
       ||native?.textContent?.trim()||"ADD TO CART");
   const cleanLabel=raw.replace(/^\[|\]$/g,"").replace(/\s*\+\s*$/,"").trim().slice(0,26);
   if(label)label.textContent="["+cleanLabel+(!waiting&&!buy.disabled?"+":"")+"]";
   const price=details.querySelector('product-price[data-product-id] .reverse-sale-card__price,product-price[data-product-id] .price > bdi');
   if(price?.textContent?.trim())dock.querySelector("[data-pdpref-price]").textContent=price.textContent.trim();
   const h=Math.max(70,Math.ceil(dock.getBoundingClientRect().height));
   const newHeight=h+"px";
   if(root.style.getPropertyValue("--pdpref-rail-height")!==newHeight)
     root.style.setProperty("--pdpref-rail-height",newHeight);
   // Hand-off happens at the SIZE SELECTION / TRY ON area, not at the end
   // of all product, materials and shipping information.
   const picker=state.handoffTarget && state.handoffTarget.isConnected
     ?state.handoffTarget
     :details.querySelector(".pdp04-main-picker .pdp04-size-option, .pdp04-main-picker, [data-pdp-size-guide], variant-picker");
   state.handoffTarget=picker||null;
   const marker=picker?.getBoundingClientRect();
   const reachedSizing=!!marker && marker.top<=innerHeight-h-12;
   // Fallback only if no size-picker is available.
   const nativeForm=details.querySelector(".buy-buttons-block");
   const nativeTop=nativeForm?.getBoundingClientRect().top;
   const fallback=marker?false:(nativeTop!=null && nativeTop<=innerHeight-h-12);
   // The header follows the hero only as long as its floating Add to Cart
   // rail is actually visible. Same cutoff and state as the rail itself.
   // The navigation stays accessible while its mobile drawer is open.
   const media=root.querySelector(".product-information__media");
   const mediaRect=media?.getBoundingClientRect();
   const bounds=details.getBoundingClientRect();
   const show=mobile() && !menuIsOpen() && !!mediaRect && mediaRect.bottom>0
     && bounds.bottom>h && !reachedSizing && !fallback;
   dock.dataset.visible=show?"true":"false";
   const navigationOpen=menuIsOpen();
   document.documentElement.classList.add("pdpref04-follow-header");
   document.documentElement.classList.toggle(
     "pdpref04-follow-header-paused",!show && !navigationOpen
   );
   // Keep the actual ASSIST tab out of the hero purchase rail.
   // Normal chat positioning resumes at the size picker hand-off.
   document.documentElement.classList.toggle("pdpref04-hero-dock-visible",!!show);
 }
 function tick(){
   if(raf)return;raf=requestAnimationFrame(()=>{raf=0;for(const item of seen)sync(item)});
 }
 function boot(root){
   // V4 EDITORIAL PARITY 12 OCT: shared product info across viewports.
   if(instances.has(root))return;
   const details=root.querySelector(".product-details");
   const dock=root.querySelector("[data-pdpref-dock]");
   const buy=dock?.querySelector("[data-pdpref-buy]");
   const info=dock?.querySelector("[data-pdpref-info]");
   if(!details||!dock||!buy)return;
   dock.hidden=!mobile();
   const state={root,details,dock,buy,info,native:null,
     originalRows:[],intro:null,materialOriginal:null,
     generatedMaterials:null,modelNote:null,modelSource:null,buyHandler:null,infoHandler:null};
   instances.set(root,state);seen.add(state);
   if(mobile())attachHeaderToViewport();
   ensureMaterialsDisclosure(state);
   makeHeaderLinks(state);
   moveMaterials(state);
   moveModelInfo(state);
   state.buyHandler=()=>{sync(state);if(!buy.disabled&&state.native)state.native.click()};
   buy.addEventListener("click",state.buyHandler);
   state.infoHandler=()=>{
     const anchor=details.querySelector(".pdpref04-intro")||details;
     const reduce=matchMedia("(prefers-reduced-motion:reduce)").matches;
     anchor.scrollIntoView({behavior:reduce?"auto":"smooth",block:"start"});
   };
   info?.addEventListener("click",state.infoHandler);
   // Prevent a tap on the dock from showing a stale cart when a variant changes.
   const observer=new MutationObserver(tick);
   observer.observe(details,{subtree:true,attributes:true,attributeFilter:["disabled","aria-disabled"],childList:true,characterData:true});
   state.observer=observer;
   sync(state);
 }
 function teardown(state){
   state.observer?.disconnect();
   state.buy?.removeEventListener("click",state.buyHandler);
   state.info?.removeEventListener("click",state.infoHandler);
   document.documentElement.classList.remove("pdpref04-hero-dock-visible","pdpref04-follow-header","pdpref04-follow-header-paused");
   state.intro?.remove();
   const moved=state.materialOriginal;
   if(moved?.parent?.isConnected){
     const before=moved.nextSibling?.parentNode===moved.parent?moved.nextSibling:null;
     moved.parent.insertBefore(moved.note,before);
     moved.note.classList.remove("pdpref04-material-in-accordion");
   }
   state.generatedMaterials?.remove();
   state.modelNote?.remove();
   state.modelSource?.classList.remove("pdpref04-model-source-hidden");
   for(const saved of state.originalRows){
     saved.wrapper?.classList?.remove("pdpref04-source-collapsed","pdpref04-source-revealed");
     if(saved.row?.isConnected)saved.row.open=saved.originalOpen;
   }
   state.root.style.removeProperty("--pdpref-rail-height");
   state.dock.dataset.visible="false";
   state.dock.hidden=true;
   seen.delete(state);instances.delete(state.root);
   if(seen.size===0)restoreHeaderPosition();
 }
 const start=()=>{
   // Shared details on desktop; floating purchase bar only on mobile/tablet.
   document.querySelectorAll(rootSelector).forEach(boot);
   if(mobile()){
     if(seen.size)attachHeaderToViewport();
     for(const state of seen)state.dock.hidden=false;
   }else{
     restoreHeaderPosition();
     document.documentElement.classList.remove(
       "pdpref04-hero-dock-visible","pdpref04-follow-header","pdpref04-follow-header-paused"
     );
     for(const state of seen){
       state.dock.dataset.visible="false";
       state.dock.hidden=true;
     }
   }
   for(const state of [...seen])if(!state.root.isConnected)teardown(state);
   tick();
 };
 document.addEventListener("nav04:change",tick);
 document.addEventListener("toggle",(event)=>{
   if(event.target?.matches?.('header-drawer #Details-menu-drawer-container'))tick();
 },true);
 window.addEventListener("scroll",tick,{passive:true});
 // The theme can scroll .page-wrapper rather than window on iOS.
 document.addEventListener("scroll",tick,{passive:true,capture:true});
 window.addEventListener("resize",start,{passive:true});
 document.addEventListener("shopify:section:load",start);
 if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
 else start();
})();
